import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Text, Margin } from 'shared/components'
import CustomIcon from 'shared/components/customIcon'
import * as styles from './styles'

const MobileInfoContentComponent = () => {
	const [activeSection, setActiveSection] = useState('menu')

	const infoSections = [
		{
			id: 'privacy',
			title: 'Privacy Policy'
		},
		{
			id: 'terms',
			title: 'Terms of Use'
		},
		{
			id: 'contact',
			title: 'Contact Us'
		}
	]

	const renderPrivacyPolicy = () => (
		<div css={styles.contentSection}>
			<div css={styles.headerWithBack}>
				{renderBackButton()}
				<Margin bottom={2}>
					<Text as="h2" size={16} white bold>
						Privacy Policy
					</Text>
				</Margin>
			</div>
			<div css={styles.scrollableContainer}>
				<div css={styles.textContainer}>
					<Text size={11}>
						The Privacy Policy (hereinafter referred to as the{' '}
						<Text size={11} bold>"Policy"</Text>) describe the way of collecting, using and
						subsequent dealing with personal data collected via both the
						<Text size={11} italic>
							<a css={styles.linkCustom} href="https://inwin.online/">
								{' '}
								www.inwin.online{' '}
							</a>
						</Text>
						website (hereinafter referred to as the <Text size={11} bold>"website"</Text>)
						and the InWin mobile application available via both the Google Play
						Store and Apple's App Store.
					</Text>
					<Text size={11} underline>Personal data controller:</Text>
					<Text size={11}>
						<Text size={11} bold>InWin Corporation.</Text>, with registered office at
						Hoboken Riverfront Center, 9th floor 221 River Street Hoboken, NJ
						07030, USA
					</Text>
					<Text size={11}>
						Registration No 0450358254, registered with the New Jersey Department
						of the Treasury, Division of Revenue and Enterprise Services
					</Text>
					<Text size={11} underline>Contact details:</Text>
					<Text size={11}>
						Delivery address: Hoboken Riverfront Center, 9th floor, 221 River
						Street, Hoboken, NJ 07030, USA
					</Text>
					<Text size={11}>Contact e-mail: compliance@inwin.online</Text>
					<Text size={11}>Contact phone number: 732 77 11 657</Text>
					<Margin bottom={2} top={2}>
						<Text size={11} bold>
							Personal data protection is very important to us. Please acquaint
							with the Policy which contains important information regarding the
							usage of your personal data, related rights and obligations.
						</Text>
					</Margin>
					{/* one */}
					<Margin>
						<Text size={11} bold uppercase>
							1. GENERAL PROVISIONS
						</Text>
						<Margin top={2} left={4}>
							<Text size={11} bold>
								1.1. What governs our relationship when dealing with personal data
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								Dealing with personal data is governed by the federal laws and
								regulations of the United States of America and those of the State
								of New Jersey.
							</Text>
						</Margin>

						<Margin top={2} left={4}>
							<Text size={11} bold>1.2. What personal data do we collect?</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								Personal data means any information relating to an identified or
								identifiable natural person. Personal data is particularly (but
								not exclusively):
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11} bold>– Identification data</Text>, such as the name and
								surname, username of an account;
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11} bold>– Contact data</Text>, such as e-mail address;
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11} bold>– Other data</Text>, such as information collected via
								cookies, IP address (network identifier) including the type of web
								browser, the device and operating system, duration and number of
								accesses to the website and corresponding information.
							</Text>
						</Margin>
					</Margin>
					{/* one end */}

					<Margin>
						<Text size={11} bold>2. COLLECTING AND USING PERSONAL DATA</Text>
						<Margin top={2} left={4}>
							<Text size={11} bold>2.1. How do we collect your personal data?</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You provide us with your personal data particularly by completing
								your registration within the website (or by filling a contact
								form).{' '}
								<Text size={11} bold>
									Please inform us if there is any change of your personal data.{' '}
								</Text>
								Some personal data can be collected and saved via cookies during
								your visit on the website. You can read more about cookies in the
								Article 5 of the Policy.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>
								2.2. On which basis and for which purposes do we process your
								personal data?
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								– We can collect and process information provided
								<Text size={11} bold> within registration </Text>and personal data necessary
								for providing our services without your explicit consent solely
								for the purpose of<Text size={11} bold> performance of the contract </Text>,
								which means for the purpose of the purpose of permitting
								<Text size={11} bold>
									{' '}
									you access, administration and management of your user account
									and providing our services.{' '}
								</Text>
								We can further process the data in order to comply with our other
								obligations imposed by law (e. g. archiving of invoices etc.) and
								for the purpose of protection of our legal claims.
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>
									– We are entitled to use your e-mail address without your
									explicit consent for the purpose of sending commercial
									communications regarding our services similar to those we have
									provided to you. You can refuse sending of these commercial
									communications at any time.
								</Text>
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>
									– After your consent via confirmation on the website, we can
									process your personal data insert while ordering services or
									within registration in order to send the commercial
									communications and direct marketing, eventually for additional
									reasons to which you have explicitly consented.
								</Text>
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>
									– If we process personal data collected via
									<Text size={11} bold> cookies </Text>, we do so on the basis of your consent
									(which you give us in applicable Settings of your Internet
									browser) on the basis of our legitimate interest or for the
									purpose of a performance of the contract. We use data collected
									via cookies in particular for the purpose of user support,
									improving our services including analysis of user&apos;s behaviour
									and marketing.
								</Text>
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>
								We will ask for your consent before using data for a purpose other
								than those that are set out above.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>2.3. For how long do we use the data?</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								We use the personal data insert by filling a contact form or
								within the registration on the website, solely for the time
								necessary to fulfill the contract and obligations imposed by law,
								respectively for protection of our legal claims. If you give us
								explicit consent to process personal data or if we use your e-mail
								address for commercial communications, the data will be used for
								the time our website, on which we provide services similar to
								those we have already provided to, is functioning, eventually for
								the time stated in the consent.
							</Text>
						</Margin>
					</Margin>

					<Margin>
						<Margin>
							<Text size={11} bold>3. YOUR RIGHTS IN RELATION TO PERSONAL DATA</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.1. Right to withdraw consent</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								If we process your personal data solely based on your consent
								(i.e. without any other legal purpose), you can decide to withdraw
								your consent at any time. The withdrawal of consent to processing
								personal data is possible at any time:
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>– by sending an e-mail to our contact email address;</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								– in case of commercial communications – in a way which is
								indicated in every e-mail containing commercial communications (by
								clicking on a deregistering link or by another way).
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								Withdrawal of consent does not affect the legality of personal
								data processing done before the withdrawal.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.2. Right of access by the data subject</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You have the right to be informed about processing of your data
								and eventually to access your personal data, in particular to get
								the following information:
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>– purpose of processing;</Text>
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>– category of processed personal data;</Text>
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>
									– recipient or category of recipients to whom will be the
									personal data accessible;
								</Text>
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11}>– time for which will be the personal data saved.</Text>
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								We will provide you with the copy of your personal data at your
								request. For further copies, we may request a reasonable
								compensation not exceeding necessary costs for providing the
								information about processing of your personal data.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.3. Right to rectification</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You have the right to request an imminent rectification of your
								incorrect or inaccurate data, i.e. rectification of incorrect data
								or/and complement of inaccurate data.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.4. Right to object to processing</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You have the right to object to processing of your processed
								personal data at any time, if we process these data for the
								purpose of direct marketing including any automatic process of
								your personal data. After the objection, we will stop processing
								your personal data for these purposes.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.5. Right to erasure ("right to be forgotten")</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You have the right to request the erasure of your personal data
								if:
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								– the personal data are no long needed for purposes for which the
								data was collected or processed;
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>– you decided to withdraw the consent with processing;</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>– you objected to processing of the personal data;</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>– the personal data were processed illegally.</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								If there are no legal reasons for the refusal of erasure, we must
								comply with your request. You can request to erase your personal
								data either via Contact Details as specified in the beginning of
								this Privacy Policy OR via the following URL:
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								<a
									css={styles.linkCustom}
									href="https://app.inwin.online/fe/main/user-data-deletion-request"
								>
									https://app.inwin.online/fe/main/user-data-deletion-request
								</a>
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.6. Right to restriction of processing</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You have the right to request the restriction of processing of
								your personal data if:
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>– the accuracy of the data is contested;</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								– the processing is illegal, and you request the restriction of
								personal data instead of erasure;
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								- we no longer need your personal data for the purpose of
								processing, but you request these data for determining, execution
								or protection of your legal rights;
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>– you object to processing.</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								When the processing is restricted, we are only entitled to save
								your personal data; further processing is possible solely with
								your consent or for legal purposes.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								If the processing of personal data is restricted for reason of
								your objection to processing, the restriction lasts for the time
								necessary to find, whether we are obliged to comply with the
								objection.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								If the processing of personal data is restricted for reason of
								accuracy contestation of your personal data, the restriction lasts
								for the time of verification of the data accuracy.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>3.7. Right to data portability</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								You have the right to collect the personal data you have provided
								us with, in the structured, commonly used and machine-readable
								format and to transmit these data to another personal data
								controller.
							</Text>
						</Margin>
					</Margin>

					<Margin>
						<Margin>
							<Text size={11} bold>4. USAGE AND PROCESSING OF PERSONAL DATA</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>4.1. Who processes your personal data?</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								We are the controller of your personal data in the meaning of the
								Regulation. When necessary for performance of the contract or to
								comply our obligations, we can transfer your personal data to
								another subject, for example to persons involved in the
								performance of the contract or in compliance with our obligations.
								We can delegate also other processors and recipients of personal
								data. At your request, we will inform you about concrete processor
								of your data. Your personal data will not be transferred to a
								state outside of the European Union, unless it is necessary for
								the performance of the contract or for another reason which is in
								compliance with rules stipulated by the Regulation.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>4.2. How do we process personal data?</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								Personal and other collected data are highly protected against any
								misuse. Personal data will be processed electronically in an
								automated manner.
							</Text>
						</Margin>
					</Margin>

					<Margin>
						<Margin>
							<Text size={11} bold>5. THE COOKIE FILES</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11} bold>5.1. What are cookies</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								The cookie files or so called<Text size={11} bold> "cookies" </Text>are text
								files, saved in a computer or another electronic device of every
								visitor of the website, which allow an analysis of a manner of
								using the website.
							</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								Not all cookies collect your personal data; some of them only
								enable correct operation of the website. You can refuse using
								cookies in applicable Settings of your Internet browser.
							</Text>
						</Margin>

						<Margin top={2} left={4}>
							<Text size={11} bold>5.2. Which cookies the website uses</Text>
						</Margin>
						<Margin top={2} left={4}>
							<Text size={11}>
								The website uses<Text size={11} bold> relational (temporary) cookies </Text>
								which are automatically erased after the leaving of the website.
								Furthermore, it may use<Text size={11} bold> permanent cookies </Text>,
								which remain in your device until they expire or you delete it.
								The website may use:
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11} bold>– first party cookies</Text> – these cookies are
								assigned to the domain of our website; these are necessary cookies
								and performance cookies, which we use even before conclusion of
								the contract for the purpose of performance of the contract, on
								the basis of our legitimate interests or on the basis of your
								consent. They can be temporary or permanent.
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11} bold>– session cookies</Text> – allow navigation on the
								website and the use of basic functions, these cookies do not
								collect personal data, i.e. they usually do not identify you;
							</Text>
						</Margin>
						<Margin top={2} left={6}>
							<Text size={11}>
								<Text size={11} bold>– analytical cookies</Text> – serve for analysis of the
								way of using website (the number of visits, duration of time spent
								on the website etc.), the data collected by these cookies are
								anonymous;
							</Text>
						</Margin>
					</Margin>
					<Margin top={4}>
						<Text size={11}>
							<Text size={11} bold>The Privacy Policy </Text>
							is valid and effective as of July 10th, 2021
						</Text>
					</Margin>
				</div>
			</div>
		</div>
	)

	const renderTermsOfUse = () => (
		<div css={styles.contentSection}>
			<div css={styles.headerWithBack}>
				{renderBackButton()}
				<Margin bottom={2}>
					<Text as="h2" size={16} white bold>
						Terms of Use
					</Text>
				</Margin>
			</div>
			<div css={styles.textContainer}>
				<Text size={11}>
					By using the InWin platform, you agree to abide by our terms and conditions.
					For the complete and detailed Terms of Use document, please visit:
				</Text>
				<div css={styles.linkContainer}>
					<a
						css={styles.externalLink}
						href="https://inwin.online/static/media/InWin_T&C_v1.3.3622541f.pdf"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Text size={12} bold>
							View Full Terms & Conditions (PDF)
						</Text>
					</a>
				</div>
				<Text size={11}>
					Key points include:
				</Text>
				<Margin left={2}>
					<Text size={11}>
						• Users must be 18 years or older to participate
					</Text>
					<Text size={11}>
						• All bets placed through InWin support charitable causes
					</Text>
					<Text size={11}>
						• Fair play and responsible gaming policies apply
					</Text>
					<Text size={11}>
						• Account suspension may occur for violations
					</Text>
				</Margin>
			</div>
		</div>
	)

	const renderContactUs = () => (
		<div css={styles.contentSection}>
			<div css={styles.headerWithBack}>
				{renderBackButton()}
				<Margin bottom={2}>
					<Text as="h2" size={16} white bold>
						Contact Us
					</Text>
				</Margin>
			</div>
			<div css={styles.textContainer}>
				<Text size={11}>
					Have questions or need support? We're here to help!
				</Text>

				<div css={styles.contactMethod}>
					<div>
						<Text size={12} bold white>Email Support: </Text>
						<a css={styles.linkCustom} href="mailto:info@inwin.online">
							<Text size={11}>info@inwin.online</Text>
						</a>
					</div>
				</div>

				<div css={styles.contactMethod}>
					<div>
						<Text size={12} bold white>Phone: </Text>
						<a css={styles.linkCustom} href="tel:+17327711657">
							<Text size={11}>732 77 11 657</Text>
						</a>
					</div>
				</div>

				<div css={styles.contactMethod}>
					<div>
						<Text size={12} bold white>Address: </Text>
						<Text size={11}>
							Hoboken Riverfront Center, 9th floor<br />
							221 River Street<br />
							Hoboken, NJ 07030, USA
						</Text>
					</div>
				</div>

				<div css={styles.businessHours}>
					<Text size={12} bold white>Business Hours: </Text>
					<Text size={11}>
						Monday - Friday: 9:00 AM - 6:00 PM EST<br />
						Saturday - Sunday: 10:00 AM - 4:00 PM EST
					</Text>
				</div>
			</div>
		</div>
	)

	const renderMenu = () => (
		<div css={styles.menuContainer}>
			{infoSections.map((section) => (
				<button
					key={section.id}
					css={styles.menuItem}
					onClick={() => setActiveSection(section.id)}
				>
					<Text size={11} white>{section.title}</Text>
					<CustomIcon
						icon="angleRight"
						css={styles.chevronIcon}
						size={20}
					/>
				</button>
			))}
		</div>
	)

	const renderBackButton = () => (
		<FontAwesomeIcon
			icon="arrow-left"
			css={styles.backArrow}
			onClick={() => setActiveSection('menu')}
		/>
	)

	const renderContent = () => {
		switch (activeSection) {
			case 'privacy':
				return renderPrivacyPolicy()
			case 'terms':
				return renderTermsOfUse()
			case 'contact':
				return renderContactUs()
			default:
				return renderMenu()
		}
	}

	return (
		<div css={styles.container}>
			{renderContent()}
		</div>
	)
}

export default MobileInfoContentComponent 
